export class ShippingProviderModel {

    public constructor(init?: Partial<Pick<ShippingProviderModel, keyof ShippingProviderModel>>) {

        if (init) {
            Object.assign(this, init);
        }
    }

    id: number;
    name: string;
    description: string;

    phone: string;
    whatsappPhone: string;

    schedule: string;
    expressSchedule: string;

    isAvailable = true;

    shippingByGivi = false;
    
    type = ShippingProviderType.Express;

    deliveryZone: string;

    deliveryTime: string;

    isFreeShipping = false;
}


export enum ShippingProviderType {
    None = 0,
    Express = 1,
    Appointment = 2
}